export default {
    removeSuccessMSG: {
        fr: 'Téléconsultation annulée avec succès',
        en: 'Teleconsultation cancelled successfulyl',
    },
};
